let activeReceptorModelId = 'trr-archer'

export const setGrcWizardReceptorModelId = (modelId: string): void => {
  activeReceptorModelId = modelId
}

export const getGrcWizardReceptorModelId = (): string => activeReceptorModelId

const DISPLAY_NAMES: Record<string, string> = {
  'trr-archer': 'Archer',
  'trr-anecdotes': 'Anecdotes',
  'trr-metricstream': 'MetricStream',
}

export const getGrcWizardReceptorDisplayName = (): string =>
  DISPLAY_NAMES[activeReceptorModelId] || activeReceptorModelId
